import { render } from "./ForgotPassword.vue?vue&type=template&id=cad9da5a&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=cad9da5a&scoped=true&lang=css"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad9da5a"]])

export default __exports__